/* eslint-disable no-undef */
import axios from 'axios'
import qs from 'qs';
import VueAxios from 'vue-axios'
import Vue from 'vue'
import config from '@/config/config'
import { Message } from 'element-ui'

Vue.use(VueAxios, axios)

// 创建axios实例
const request = axios.create({
  baseURL: config.baseURL, // 后端接口地址
  timeout: 10000,
  withCredentials: true,
  // 关键：配置参数序列化规则，保留 null 值
  paramsSerializer: (params) => {
    return qs.stringify(params, {
      skipNulls: false, // 核心配置：false → 保留 null 值的参数（默认 true 会过滤）
      allowDots: true // 支持对象嵌套参数（可选）
    });
  }
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 可以在这里添加token等信息
    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    const newToken = response.headers['new-token'];
    if (newToken) {
      // 直接覆盖 sessionStorage 中的旧 token
      sessionStorage.setItem('token', newToken); 
    }

    // 若请求类型是 blob，返回完整 response（否则前端无法拿到 Blob 对象）
    if (response.config.responseType === 'blob') {
      return response;
    }
    return response.data
  },
  error => {
    if (error.response) {
      if (error.response.status === 401) {
        // 拦截 401 未登录或 Token 彻底过期
        Message.error('登录已过期，请重新登录');
        sessionStorage.removeItem('token');
        // 如果当前不在登录页，则跳转回登录页
        if (window.location.hash !== '#/login') {
             window.location.href = '/#/login';
        }
      } else if (error.response.status === 403) {
        // 拦截 403 权限不足
        Message.error(error.response.data.message || '无操作权限，请联系管理员');
      } else {
        // 其他状态码（如 500）的通用提示
        Message.error(error.response.data.message || '请求失败');
      }
    } else {
      Message.error('网络异常，请稍后再试');
    }
    return Promise.reject(error)
  }
)

export default request